import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const OnboardingWizard = lazy(() => import('../../container/onboarding/OnboardingWizard'));

function OnboardingRoute() {
  return (
    <Routes>
      <Route path="client" element={<OnboardingWizard />} />
    </Routes>
  );
}

export default OnboardingRoute;
